import Head from 'next/head'
import { ProgramsPage } from '../../components/corporate/ProgramsPage'

export default function CorporateProgramsRoute() {
    return (
        <>
            <Head>
                <title>Programs | Corporate Wellness | StringsSG</title>
                <meta charSet="utf-8" />
                <meta name="robots" content="noindex" />
                <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
                <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no" />
                <meta name="description" content="Corporate Wellness Programs | StringsSG" />
                <link rel="icon" href="/favicon.ico" />
            </Head>
            <div className="max-w-4xl mx-auto overflow-hidden">
                <ProgramsPage />
            </div>
        </>
    )
}
